import React from 'react';
import { useLocation } from 'react-router-dom';



const PDFrender = () => {

    const location = useLocation();

    return (

        // <object data={location.state.file} type="application/pdf" width="100%" height={window.innerHeight / 1.12}>
        //     <p>Your link <a href="virgilia-report.pdf">to the PDF!</a></p>
        // </object>
        <div>
            <iframe
                title="virgilia-report.pdf"
                type="application/pdf"
                src={location.state.file}
                height={window.innerHeight / 1.12}
                width="100%"
            ><p>Your browser is outdated or does not support iframe element rendering</p></iframe>
        </div>
    );
}
export default PDFrender

